import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchType: 'duration',
  distance: '5',
  duration: '30',
  transportType: 'bike',
  transportDateTime: undefined,
  daysSinceReleaseLimit: '30',
  jobDomain: [],
  job: [],
  workSchedule: undefined,
  timeArrangement: [],
  contractType: undefined,
  educationLevel: undefined,
  degree: undefined,
  languages: [],
  driverLicense: [],
  refundBusTrain: false,
  organizationCollectiveTransport: false,
  organizationCarpool: false,
  carSharingSubscription: false,
  electricCarChargingStation: false,
  companyCar: false,
  telecommutingIsPossible: false,
  flexibleHours: false,
  bicycleAllowance: false,
  companyOrLeaseBikes: false,
  chargingStationEBikes: false,
  changingRoomAndOrShowers: false,
};

const filter = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    updateSearchType: (state, action) => {
      state.searchType = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'search type',
        filter_name: 'search type',
        filter_value: action.payload,
      });
    },
    updateDistance: (state, action) => {
      state.distance = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'distance',
        filter_name: 'distance',
        filter_value: action.payload,
      });
    },
    updateDuration: (state, action) => {
      state.duration = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'duration',
        filter_name: 'duration',
        filter_value: action.payload,
      });
    },
    updateTransportType: (state, action) => {
      state.transportType = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'transport type',
        filter_name: 'transport type',
        filter_value: action.payload,
      });
    },
    updateTransportDateTime: (state, action) => {
      state.transportDateTime = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'transport datetime',
        filter_name: 'transport datetime',
        filter_value: action.payload,
      });
    },
    updateDaysSinceReleaseLimit: (state, action) => {
      state.daysSinceReleaseLimit = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'days since vacancy release',
        filter_name: 'days since vacancy release',
        filter_value: action.payload,
      });
    },
    updateJobDomain: (state, action) => {
      state.jobDomain = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'job domain',
        filter_name: 'job domain',
        filter_value: action.payload?.map(i => i.id)?.join(', '),
      });
    },
    updateJob: (state, action) => {
      state.job = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'job',
        filter_name: 'job',
        filter_value: action.payload?.map(i => i.id)?.join(', '),
      });
    },
    updateWorkSchedule: (state, action) => {
      state.workSchedule = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'work schedule',
        filter_name: 'work schedule',
        filter_value: action.payload,
      });
    },
    updateTimeArrangement: (state, action) => {
      state.timeArrangement = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'time arrangement',
        filter_name: 'time arrangement',
        filter_value: action.payload?.map(i => i.id)?.join(', '),
      });
    },
    updateContractType: (state, action) => {
      state.contractType = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'contract type',
        filter_name: 'contract type',
        filter_value: action.payload,
      });
    },
    updateEducationLevel: (state, action) => {
      state.educationLevel = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'education level',
        filter_name: 'education level',
        filter_value: action.payload,
      });
    },
    updateDegree: (state, action) => {
      state.degree = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'degree',
        filter_name: 'degree',
        filter_value: action.payload,
      });
    },
    updateLanguages: (state, action) => {
      state.languages = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'languages',
        filter_name: 'languages',
        filter_value: action.payload?.map(i => i.id)?.join(', '),
      });
    },
    updateDriverLicense: (state, action) => {
      state.driverLicense = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'driver license',
        filter_name: 'driver license',
        filter_value: action.payload?.map(i => i.id)?.join(', '),
      });
    },
    updateRefundBusTrain: (state, action) => {
      state.refundBusTrain = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'refund bus/train',
        filter_name: 'refund bus/train',
        filter_value: action.payload,
      });
    },
    updateOrganizationCollectiveTransport: (state, action) => {
      state.organizationCollectiveTransport = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'organization collective transport',
        filter_name: 'organization collective transport',
        filter_value: action.payload,
      });
    },
    updateOrganizationCarpool: (state, action) => {
      state.organizationCarpool = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'organization carpool',
        filter_name: 'organization carpool',
        filter_value: action.payload,
      });
    },
    updateCarSharingSubscription: (state, action) => {
      state.carSharingSubscription = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'car sharing subscription',
        filter_name: 'car sharing subscription',
        filter_value: action.payload,
      });
    },
    updateElectricCarChargingStation: (state, action) => {
      state.electricCarChargingStation = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'electric car charging station',
        filter_name: 'electric car charging station',
        filter_value: action.payload,
      });
    },
    updateCompanyCar: (state, action) => {
      state.companyCar = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'company car',
        filter_name: 'company car',
        filter_value: action.payload,
      });
    },
    updateTelecommutingIsPossible: (state, action) => {
      state.telecommutingIsPossible = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'telecommuting is possible',
        filter_name: 'telecommuting is possible',
        filter_value: action.payload,
      });
    },
    updateFlexibleHours: (state, action) => {
      state.flexibleHours = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'flexible hours',
        filter_name: 'flexible hours',
        filter_value: action.payload,
      });
    },
    updateBicycleAllowance: (state, action) => {
      state.bicycleAllowance = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'bicycle allowance',
        filter_name: 'bicycle allowance',
        filter_value: action.payload,
      });
    },
    updateCompanyOrLeaseBikes: (state, action) => {
      state.companyOrLeaseBikes = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'company or lease bikes',
        filter_name: 'company or lease bikes',
        filter_value: action.payload,
      });
    },
    updateChargingStationEBikes: (state, action) => {
      state.chargingStationEBikes = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'charging station ebikes',
        filter_name: 'charging station ebikes',
        filter_value: action.payload,
      });
    },
    updateChangingRoomAndOrShowers: (state, action) => {
      state.changingRoomAndOrShowers = action.payload;
      window.gtag?.('event', 'filter_changed', {
        event_category: 'Filter',
        event_label: 'changing room and or showers',
        filter_name: 'changing room and or showers',
        filter_value: action.payload,
      });
    },
  },
});

export const { 
  updateSearchType,
  updateDistance,
  updateDuration,
  updateTransportType,
  updateTransportDateTime,
  updateDaysSinceReleaseLimit,
  updateJobDomain,
  updateJob,
  updateWorkSchedule,
  updateTimeArrangement,
  updateContractType,
  updateEducationLevel,
  updateDegree,
  updateLanguages,
  updateDriverLicense,
  updateRefundBusTrain,
  updateOrganizationCollectiveTransport,
  updateOrganizationCarpool,
  updateCarSharingSubscription,
  updateElectricCarChargingStation,
  updateCompanyCar,
  updateTelecommutingIsPossible,
  updateFlexibleHours,
  updateBicycleAllowance,
  updateCompanyOrLeaseBikes,
  updateChargingStationEBikes,
  updateChangingRoomAndOrShowers,
} = filter.actions;

export default filter.reducer;
